<template>
  <div class="contract-view-container">
    <div v-if="contract">
      <!-- Detalhes do Contrato -->
      <detail 
        :contract="contractDetail" 
        :orders="formattedOrders"        
      ></detail>
      
      <!-- Dashboard de Métricas -->
      <div class="metrics-section" v-if="contract2">
        <gauges-dashboard :selected_contract="contract2" :is_dependent="true"></gauges-dashboard>
      </div>
      
      <!-- Gráficos -->
      <div class="charts-section">
        <div class="chart-container">
          <div class="chart-header">
            <h3 class="chart-title">Compras por Mês</h3>
          </div>
          <div class="chart-content">
            <MonthPurchases :contract="contract"></MonthPurchases>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Loading State -->
    
  </div>
</template>

<script>
import GaugesDashboard from "./../GaugesDashboard.vue";
import MonthlyAmountOrders from "./../Charts/MonthAmountOrders.vue";
import MonthPurchases from "./../Charts/MonthPurchases.vue";
import Detail from "./Detail.vue";
export default {
  components: {
    MonthlyAmountOrders,
    MonthPurchases,
    Detail,
    GaugesDashboard,
  },
  data() {
    return {
      loadingReport: false,
      loading: true,
      contract: null,
      contract2: null,
      number_of_orders_to_show: 5,
      total_orders_page: 1,
      actual_order_page: 1,
    };
  },
  computed: {
    formattedOrders() {
      if (!this.contract || !this.contract.orders) return [];
      
      return this.contract.orders.map(order => ({
        number: order.C5_NUM,
        measurement: order.C5_MDNUMED,
        product: `${order.C6_PRODUTO} - ${order.B1_DESC}`,
        quantity: this.formatNumber(order.C6_QTDVEN),
        value: this.format_currency(order.C6_VALOR),
        status: order.C5_NOTA && order.C5_NOTA.trim() ? 'Faturado' : 'Pendente',
        statusClass: order.C5_NOTA && order.C5_NOTA.trim() ? 'bg-success' : 'bg-danger'
      }));
    },
    contractDetail() {

      console.log(this.contract);
      if (this.contract) {


        if (this.contract.CNB_ZUNFAT.trim() != "") {

          this.contract.CNB_UM = this.contract.CNB_ZSEGUN;

          if (this.contract.CNB_ZTPCON.trim() == '1') {
            this.contract.CNB_QTDMED = this.contract.CNB_QTDMED * this.contract.CNB_ZCONV;
            this.contract.CNB_QUANT = this.contract.CNB_QUANT * this.contract.CNB_ZCONV;
            this.contract.CNB_SLDMED = this.contract.CNB_SLDMED * this.contract.CNB_ZCONV;            
            this.contract.CNB_VLUNIT = this.contract.CNB_VLUNIT / this.contract.CNB_ZCONV;
          } else {
            this.contract.CNB_QTDMED = this.contract.CNB_QTDMED / this.contract.CNB_ZCONV;
            this.contract.CNB_QUANT = this.contract.CNB_QUANT / this.contract.CNB_ZCONV;
            this.contract.CNB_SLDMED = this.contract.CNB_SLDMED / this.contract.CNB_ZCONV;
            this.contract.CNB_VLUNIT = this.contract.CNB_VLUNIT * this.contract.CNB_ZCONV;
          }

        }
      }

      return this.contract;
    }
  },
  methods: {
    formatNumber(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
    },
    contractReport() {
      let api =
        this.$store.getters.api +
        "contracts/export-detail?CN9_FILIAL=" +
        this.contract.CN9_FILIAL.split('-')[0].trim() +
        "&CN9_NUMERO=" +
        this.contract.CN9_NUMERO;

      let self = this

      this.loadingReport = true

      axios
        .get(api)
        .then((response) => {

          // create file link in browser's memory
          const href = self.$store.getters.api + 'contracts/export-detail-file?hash=' + response.data.hash;

          window.open(href, '_blank').focus();
          self.loadingReport = false

        })
        .catch((error) => {
          this.$toast.error(
            "Erro na solicitação de Contratos:" + error.response.data.message
          );
          self.loadingReport = false
        });
    },
    getContract() {
      const self = this;
      let data = self.$route.params.params;
      
      self.loading = true;
      var api = self.$store.getters.api + "contracts/detail?params=" + data;

      axios
        .get(api)
        .then((response) => {
          let contract = response.data.data.ZOOM[0];
          var contract2 = response.data.data.ZOOM[0];

          self.total_orders_page = Math.ceil(contract.orders.length / 5);
          self.contract = contract;
          self.contract2 = contract2;
          self.loading = false;

          setTimeout(function () {
            self.$store.dispatch("setLoadingChartAmount", true);
          }, 5000);
        })
        .catch((error) => {
          self.loading = false;
          this.$toast.error(
            "Erro na solicitação de Contratos:" + error.response.data.message
          );
        });
    },
    format_currency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  mounted() {
    this.getContract();
  },
};
</script>

<style scoped>
/* Container Principal */
.contract-view-container {
  margin: 0;
  padding: 0;
  background: transparent;
  min-height: 100vh;
}

/* Seção de Métricas */
.metrics-section {
  margin: 0;
  margin-top: 1px;
  background: white;
  border-top: 1px solid #e9ecef;
  padding: 24px;
}

/* Seção de Gráficos */
.charts-section {
  margin: 0;
  margin-top: 1px;
  background: white;
  border-top: 1px solid #e9ecef;
}

.chart-container {
  padding: 0;
}

.chart-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.chart-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: white;
  text-align: center;
}

.chart-content {
  padding: 24px;
  background: white;
}

/* Loading State */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f8f9fa;
}

.loading-content {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}

.loading-content h4 {
  color: #495057;
  margin: 20px 0 8px 0;
  font-weight: 600;
}

.loading-content p {
  color: #6c757d;
  margin: 0;
  font-size: 14px;
}

/* Spinner */
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsividade */
@media (max-width: 768px) {
  .metrics-section,
  .chart-content {
    padding: 16px;
  }

  .chart-header {
    padding: 16px;
  }

  .chart-title {
    font-size: 18px;
  }

  .loading-content {
    margin: 16px;
    padding: 24px;
  }
}

/* Animações suaves */
.metrics-section,
.charts-section {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>